import React from 'react';
import { useNavigate } from 'react-router-dom';

const RITUALS = [
  { id: 'morning', title: 'MORNING RITUAL', description: 'Begin with intention', action: '/morning-ritual' },
  { id: 'breathe', title: 'BREATHE', description: 'Return to your body', action: '/breathe' },
  { id: 'journal', title: 'JOURNAL', description: 'Write what needs space', action: '/journal' },
  { id: 'circle', title: 'THE CIRCLE', description: 'Connect with others', action: '/circle' },
  { id: 'sage', title: 'TALK TO SAGE', description: 'I am here', action: '/chat' },
  { id: 'innerworld', title: 'THE INNER WORLD', description: 'Meet the parts of you', action: '/inner-world' },
];

const RitualIcon = ({ id }) => {
  const icons = {
    morning: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5">
        <path d="M12 3v3M5.64 5.64l2.12 2.12M3 12h3M5.64 18.36l2.12-2.12M12 18v3M16.24 16.24l2.12 2.12M18 12h3M16.24 7.76l2.12-2.12"/>
        <circle cx="12" cy="12" r="4"/>
      </svg>
    ),
    breathe: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5">
        <circle cx="12" cy="12" r="8" strokeDasharray="4 2"/>
        <circle cx="12" cy="12" r="4"/>
      </svg>
    ),
    journal: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5">
        <path d="M4 4h16v16H4z"/>
        <path d="M8 8h8M8 12h6M8 16h4"/>
      </svg>
    ),
    circle: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5">
        <circle cx="12" cy="12" r="10"/>
        <circle cx="12" cy="10" r="3"/>
        <path d="M6.168 18.849A4 4 0 0110 16h4a4 4 0 013.834 2.855"/>
      </svg>
    ),
    sage: (
      <div className="w-5 h-5 rounded-full" style={{ 
        background: 'radial-gradient(circle, rgba(201,168,76,0.8) 0%, rgba(232,180,184,0.4) 100%)',
        boxShadow: '0 0 10px rgba(201,168,76,0.4)',
      }} />
    ),
    innerworld: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5">
        <path d="M12 3l2.5 5 5.5.8-4 3.9.9 5.5-4.9-2.6-4.9 2.6.9-5.5-4-3.9 5.5-.8z" strokeLinejoin="round"/>
      </svg>
    ),
  };
  return icons[id] || null;
};

export const RitualTiles = ({ animateIn }) => {
  const navigate = useNavigate();

  return (
    <section 
      className={`mb-10 transition-all duration-700 ${animateIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
      style={{ transitionDelay: '0.4s' }}
    >
      <h2 
        className="text-xs tracking-[0.2em] mb-6 text-center"
        style={{ fontFamily: 'Jost, sans-serif', color: '#C9A84C' }}
      >
        YOUR DAILY RITUALS
      </h2>
      
      <div className="grid grid-cols-2 gap-4">
        {RITUALS.map((ritual) => (
          <button
            key={ritual.id}
            onClick={() => navigate(ritual.action)}
            className="p-5 rounded-2xl text-left transition-all duration-200 active:scale-[0.97]"
            style={{ background: '#F7F1EE' }}
            data-testid={`ritual-${ritual.id}`}
          >
            <div className="w-10 h-10 rounded-full mb-3 flex items-center justify-center" style={{ background: 'rgba(201,168,76,0.1)' }}>
              <RitualIcon id={ritual.id} />
            </div>
            <h3 className="text-xs tracking-[0.1em] mb-1" style={{ fontFamily: 'Jost, sans-serif', color: '#C9A84C' }}>
              {ritual.title}
            </h3>
            <p className="text-sm" style={{ fontFamily: 'Jost, sans-serif', color: '#8A6A61' }}>
              {ritual.description}
            </p>
          </button>
        ))}
      </div>
    </section>
  );
};

export { RITUALS };
